import { AlertTriangle, HelpCircle, Info } from 'lucide-react';

const euro = (n) => (Number(n) || 0).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
const dataIt = (d) => (d && /^\d{4}-\d{2}-\d{2}/.test(d) ? d.slice(0, 10).split('-').reverse().join('/') : d || '');

export const STATI_COSTO = {
  errore: { testo: 'Errore certo', classe: 'bg-red-100 text-red-800' },
  dubbio: { testo: 'Da controllare', classe: 'bg-amber-100 text-amber-800' },
  da_aggiornare: { testo: 'Fattura nuova', classe: 'bg-blue-100 text-blue-800' },
  senza_fattura: { testo: 'Senza fattura', classe: 'bg-gray-100 text-gray-700' },
  ok: { testo: 'Corretto', classe: 'bg-emerald-100 text-emerald-800' },
};

const Fattura = ({ f }) => (
  <div className="text-xs text-gray-600 bg-stone-50 border border-stone-200 rounded-lg p-2.5 space-y-0.5">
    <p><span className="text-gray-400">Ultima fattura</span> {f.numero ? `n. ${f.numero} ` : ''}del {dataIt(f.data)}</p>
    <p className="font-mono text-[11px] text-gray-700 break-words">{f.descrizione}</p>
    <p>{Number(f.quantita) || 0} × {euro(f.prezzo_unitario)} = {euro(f.importo)} · <span className="text-gray-800">{f.motivo}</span></p>
  </div>
);

const Righe = ({ voci, Icona, colore }) => voci.map((t) => (
  <p key={t} className={`text-xs flex gap-1.5 ${colore}`}><Icona className="h-3.5 w-3.5 flex-shrink-0 mt-0.5" />{t}</p>
));

export const RigaVerificaCosto = ({ r }) => {
  const stato = STATI_COSTO[r.stato] || STATI_COSTO.ok;
  const cambiaCosto = r.stato === 'errore' || r.stato === 'da_aggiornare';
  const cambiaVendita = r.prezzo_vendita_dopo !== r.prezzo_vendita;
  return (
    <div className="border rounded-xl p-3.5 bg-white space-y-2.5" data-testid={`verifica-costi-riga-${r.id}`}>
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="text-sm font-semibold text-gray-900">{r.nome}{r.annata ? <span className="ml-1.5 text-xs font-normal text-gray-500">{r.annata}</span> : null}</p>
          <p className="text-xs text-gray-500 truncate">{[r.cantina, r.fornitore].filter(Boolean).join(' · ')}</p>
        </div>
        <span className={`text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${stato.classe}`} data-testid={`verifica-costi-stato-${r.id}`}>{stato.testo}</span>
      </div>
      <div className="grid grid-cols-2 gap-2 text-xs">
        <p className="text-gray-500" data-testid={`verifica-costi-costo-${r.id}`}>Costo{' '}
          {cambiaCosto
            ? <span className="font-semibold text-gray-900">{euro(r.costo_mostrato)} → {euro(r.costo_corretto)}</span>
            : <span className="font-medium text-gray-800">{euro(r.costo_mostrato)}</span>}
        </p>
        <p className="text-gray-500 text-right" data-testid={`verifica-costi-vendita-${r.id}`}>Carta{' '}
          {cambiaVendita
            ? <span className="font-semibold text-gray-900">{euro(r.prezzo_vendita)} → {euro(r.prezzo_vendita_dopo)}</span>
            : <span className="font-medium text-gray-800">{euro(r.prezzo_vendita)}{r.prezzo_vendita_fisso ? ' (fissato a mano)' : ''}</span>}
        </p>
      </div>
      {r.fattura && <Fattura f={r.fattura} />}
      <Righe voci={r.dubbi || []} Icona={HelpCircle} colore="text-amber-800" />
      <Righe voci={r.note || []} Icona={Info} colore="text-gray-600" />
      {r.stato === 'errore' && (
        <p className="text-xs text-red-700 flex gap-1.5"><AlertTriangle className="h-3.5 w-3.5 flex-shrink-0 mt-0.5" />Il costo in carta non corrisponde all'ultima fattura: verrà corretto.</p>
      )}
      {(r.acquisti_precedenti || []).length > 0 && (
        <p className="text-[11px] text-gray-400">Acquisti precedenti: {r.acquisti_precedenti.map((p) => `${dataIt(p.data)} ${euro(p.netto)}/bott.`).join(' · ')} (IVA esclusa)</p>
      )}
    </div>
  );
};
